import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component<ImageCollection>({})
export default class ImageCollection extends Vue {
  //#region @Props
  /**
  * ie.
  * @Prop()
  * protected user!: User
  */

  @Prop()
  protected actions!: ImageAction[];

  @Prop()
  protected images!: Image[];
  //#endregion


  //#region @Refs
  /**
  * ie.
  * @Ref()
  * readonly anotherComponent!: AnotherComponent
  */
  //#endregion


  //#region Class properties
  /**
  * ie.
  * protected isLoading = true;
  * * protected company: Company | null = null;
  */
  //#endregion


  //#region Lifecycle Hooks / Init
  /**
  * ie.
  * protected mounted(): void {
  *  console.log('MyComponent has Mounted');
  * }
  */

  protected mounted() {
    //
  }
  //#endregion


  //#region Class methods
  /**
  * ie.
  * protected toggleLoading(): void {
  *  this.isLoading = ! this.isLoading;
  * }
  */

  protected isHidden(action: ImageAction, image: Image): boolean {
    if (action.hidden === undefined) {
      return false;
    }

    return action.hidden(image);
  }

  protected imageClass(action: ImageAction, image: Image): string {
    if (action.class === undefined) {
      return '';
    }

    if ( typeof action.class === 'string') {
      return action.class;
    }

    return action.class(image);
  }
  //#endregion


  //#region Async methods
  /**
  * ie.
  * protected async fetchUserCompany(): Promise<void> {
  *  this.company = await new Company().filter({user: this.user.id}).all();
  * }
  */
  //#endregion


  //#region Getters & Setters
  /**
  * ie.
  * protected get companyName(): string {
  *  return this?.company.name || 'N/A';
  * }
  */
  //#endregion


  //#region @Watchers
  /**
  * ie.
  * @Watch('company')
  * protected companyChanged() {
  *  console.log('Company Changed') ;
  * }
  */
  //#endregion
}

export interface Image {
  id?: string;
  name?: string;
  url_large?: string;
  url_medium?: string;
  url_thumbnail?: string;
  origin?: string;
}

export interface ImageAction {
  click: (image?: Image, index?: number) => void;
  hidden?: (image?: Image) => boolean;
  icon: string;
  class?: string | ((image?: Image) => string);
}
